import React, { useCallback, useEffect, useState } from 'react';
import HorizontalSlider from './HorizontalSlider/HorizontalSlider';
import styles from './Tabs.module.scss';
import { findMiddleElement } from './findMiddleElement';

/**
 * Renders a set of tabs with optional arrows for navigation.
 *
 * @param {Object} props - The properties for the Tabs component.
 * @param {string} [props.className] - The CSS class name for the component.
 * @param {boolean} [props.arrows=false] - Whether to show navigation arrows.
 * @param {number} [props.visibleTabs] - The maximum number of tabs to display; Optional; If not provided all tabs will be displayed to fill the space.
 * @param {number} [props.centerIndex] - The index of the tab to center initially.
 * @param {ReactNode} props.children - The tabs to render.
 * @return {JSX.Element} The rendered Tabs component.
 */
function Tabs(props) {
    const { className = '', arrows = false, visibleTabs, centerIndex: initialCenterIndex, children } = props,
        [{ isAtLeft, isAtRight, tabsInViewport, canSlide }, setSliderState] = useState({}),
        [centerIndex, setCenterIndex] = useState(initialCenterIndex),
        currentCenterIndex = findMiddleElement(tabsInViewport);

    const handleMoveLeft = useCallback(() => {
            setCenterIndex((currentCenterIndex) => currentCenterIndex - 1);
        }, [currentCenterIndex]),
        handleMoveRight = useCallback(() => {
            setCenterIndex((currentCenterIndex) => currentCenterIndex + 1);
        }, [currentCenterIndex]);

    return (
        <div className={[styles.Tabs, className].join(' ')}>
            {arrows && canSlide ? <button type="button" className={styles.leftArrow} onClick={handleMoveLeft} disabled={isAtLeft} /> : null}
            <HorizontalSlider className={styles.wrapper} visibleTabs={visibleTabs} centerIndex={centerIndex} onChange={setSliderState}>
                {children}
            </HorizontalSlider>
            {arrows && canSlide ? <button type="button" className={styles.rightArrow} onClick={handleMoveRight} disabled={isAtRight} /> : null}
        </div>
    );
}

export default Tabs;
